// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1582b97e","116":"89770545","265":"07fab81a","442":"ec03ad43","505":"2bd96903","704":"71f05562","784":"296f28c6","820":"9a3105ab","856":"946e311e","883":"89c7c77d","952":"127e69ef","996":"679b507f"}[chunkId] + ".chunk.css";
};